export default __webpack_public_path__ + "static/media/CustomQuizBanner.be5a8317.png";